exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-61f8a20a] .el-dialog__body{padding:10px 25px 30px}.detail-container .detail-table[data-v-61f8a20a]{margin-top:20px;max-height:calc(80vh - 220px);overflow-y:auto}.detail-container .detail-table[data-v-61f8a20a] .detail-table-header th{background-color:#f5f7fa;font-size:14px}\n", ""]);

// exports
